import React from "react";
import "./circleIcon.sass";
import {IconSource} from "../../../shared/enums/iconSource";
import Icon from "../common/icon/icon";

export interface ICircleIconProps {
  icon: IconSource;
}

const CircleIcon: React.FC<ICircleIconProps> = ({icon}) => {
  return (
    <span className="circle-icon">
      <Icon source={icon} />
    </span>
  );
};

export default CircleIcon;
